import React from 'react';
import { useDispatch } from 'react-redux';
import { uiOpenModalOrdersOrDeliverys } from '../../actions/uiOrderOrDeliverys';
import { ordersOrDeliverysExpList } from '../../actions/deliveryNotes';

export const BtnOrderOrDelivery = (props) => {

    const dispatch = useDispatch();

    const expedition = {
        deliverynote: props?.type === 'deliverys',
        ordercode: props?.type === 'orders',
        expcode: props?.data?.expcode ?? null,
        destination: props?.data?.destination,
    }

    const handleClick = async () => {
        dispatch(uiOpenModalOrdersOrDeliverys(props));
        dispatch(ordersOrDeliverysExpList(expedition));
    }

    return (
        <button className="btn btn-plus" onClick={handleClick}>
            +
        </button>
    )
}
